import React from 'react';
import { observer } from 'mobx-react';
import { ChoiceStore } from 'ui/base/input/store';
import { InputChangeEvent, InputProps } from 'ui/base/types';
import { Optional } from 'services/base/types';


export type RadioInputProps<T> = Omit<InputProps, 'type' | 'value' | 'onChange'> & {
  choice: string;
  store: ChoiceStore<T>;
  onChange?: (key: Optional<string>, value: Optional<T>) => void;
};

export const RadioInput = observer(<T, >({ choice, store, onChange, ...props }: RadioInputProps<T>) => {
  const actualOnChange = React.useCallback((event: InputChangeEvent) => {
    if (event.target.checked) {
      store.setSelected(choice);
    }
    if (onChange != null) {
      onChange(choice, store.value);
    }
  }, [choice, store, onChange]);

  const selected = choice === store.selected;

  return (
    <input
      type='radio'
      checked={selected}
      onChange={actualOnChange}
      {...props}
    />
  );
});
